import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Pagination from '../../common/components/elements/Pagination';
import { generalAlertError } from '../../common/utils/alerts';
import { listSuspensions, resetSuspensions } from '../../features/afterSale/afterSaleActions';
import ErrorComponent from '../../common/components/ErrorComponent';
import { after_sale_purchase_statues } from '../../common/constants';
import {
  SuspensionsListStyles,
  PageHeader,
  HeaderActions,
  SuspensionCard,
  StatusBadge,
  ActionButton,
  FilterCard,
  SearchButton,
  EmptyState,
  LoadingState,
  SuspensionsList as SuspensionsListStyled,
  InfoChip,
  PostSaleButton,
} from './SuspensionsList.styles';

function SuspensionsList() {
  const navigate = useNavigate();
  const state = useSelector((store) => store.afterSale.suspensions_page);

  const {
    loading, suspensions, total_pages, page_number, error,
  } = state;

  const [search, setSearch] = useState({
    search: '',
    date_from: '',
    date_to: '',
    vehicle_plate: '',
  });
  // const [steps, setSteps] = useState([]);

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('suspensions') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('suspensions')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('suspensions');
  //   setState({ run: true, tourActive: true });
  // };

  // useEffect(() => {
  //   suspensionsSteps(suspensions, setSteps);
  // }, [suspensions]);

  useEffect(() => {
    (async () => {
      listSuspensions(1, search);
    })();

    return () => {
      resetSuspensions();
    };
  }, []);

  const handleChange = ({ target: { value, name } }) => {
    setSearch({ ...search, [name]: value });
  };

  const searchHandler = async (e) => {
    e.preventDefault();

    if (search.date_from !== '' && search.date_to === '') {
      generalAlertError('Devi selezionare anche data al');
      return;
    }

    if (search.date_from === '' && search.date_to !== '') {
      generalAlertError('Devi selezionare anche data da');
      return;
    }

    const trimmedSearch = {
      ...search,
      search: search.search.trim(),
    };

    listSuspensions(1, trimmedSearch);
  };

  return error === null || error === undefined ? (
    <SuspensionsListStyles>
      {/* <Joyride
      steps={steps}
      continuous
      showBeacon={showBeacon}
      locale={{
        back: 'Indietro',
        close: 'Chiudi',
        last: 'Fine',
        next: 'Prossima',
        open: 'Apri il modale',
        restart: 'Riavvia il tour ',
        skip: 'Salta',
      }}
      styles={{
        options: joyrideOptions,
        buttonNext: {
          backgroundColor: '#00a651',
          outline: 'none',
        },
        buttonBack: {
          color: '#00a651',
          outline: 'none',
        },
        beaconInner: {
          backgroundColor: '#00a651',
        },
        beaconOuter: {
          borderColor: '#00a651',
          backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
        },
        buttonSkip: {
          outline: 'none',
        },
        buttonClose: {
          outline: 'none',
        },
      }}
      run={run}
      callback={(data) => handleCallbackCancellations(data, steps, setState)}
      showSkipButton
      showProgress
    /> */}
      <div className="container-fluid">
        <PageHeader>
          <h2>⏸️ Sospensioni</h2>
          <HeaderActions>
            <PostSaleButton onClick={() => navigate('/after-sale/select')}>
              Vai a Post Vendita
            </PostSaleButton>
            {/* {localStorage.getItem('suspensions') === 'done' && (
              <PostSaleButton onClick={() => fireNewQuoteTour()}>
                Tutorial
              </PostSaleButton>
            )} */}
          </HeaderActions>
        </PageHeader>

        <div className="row">
          {/* Main Content */}
          <div className="col-lg-7 col-xl-8 col-xxl-9 order-2 order-lg-1">
            {loading ? (
              <LoadingState className="suspensions-one">
                <div className="spinner-border" role="status" />
                <span>Caricamento sospensioni in corso...</span>
              </LoadingState>
            ) : (
              <>
                <SuspensionsListStyled className="suspensions-one">
                  {suspensions.length > 0 ? (
                    suspensions.map((suspension) => (
                      <SuspensionCard
                        key={suspension.id}
                        className="suspensions-two"
                      >
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-2">
                          <div className="suspension-content">
                            <div className="customer-name">
                              👤
                              {' '}
                              {suspension.quotation.insurance_request.customer.gender !== 'G'
                                ? `${suspension.quotation.insurance_request.customer.name} ${suspension.quotation.insurance_request.customer.surname}`
                                : suspension.quotation.insurance_request.customer.business_name}
                            </div>

                            <div className="suspension-details">
                              <div className="detail-row">
                                <StatusBadge>
                                  {after_sale_purchase_statues.find((status) => status.id === suspension.status)?.name}
                                </StatusBadge>
                              </div>

                              <div className="info-chips-row">
                                {suspension.quotation.insurance_request.product && (
                                  <InfoChip $highlight>
                                    📦
                                    {' '}
                                    {suspension.quotation.insurance_request.product.name}
                                  </InfoChip>
                                )}

                                {suspension.quotation.company && (
                                  <InfoChip>
                                    🏢
                                    {' '}
                                    {suspension.quotation.company.name}
                                  </InfoChip>
                                )}

                                {suspension.quotation.insurance_request.vehicle && (
                                  <InfoChip $highlight>
                                    🚗
                                    {' '}
                                    {suspension.quotation.insurance_request.vehicle.vehicle_plate}
                                  </InfoChip>
                                )}

                                {suspension.quotation.insurance_request.moto && (
                                  <InfoChip $highlight>
                                    🏍️
                                    {' '}
                                    {suspension.quotation.insurance_request.moto.moto_plate}
                                  </InfoChip>
                                )}
                              </div>

                              <div className="created-date">
                                🕐 Creato il
                                {' '}
                                {new Date(suspension.created_at).toLocaleDateString('it-IT', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center">
                            {suspension.status === 5 ? (
                              <Link to={`/suspensions/${suspension.id}`}>
                                <ActionButton>
                                  📋 Vai a sospensione
                                </ActionButton>
                              </Link>
                            ) : (
                              <Link to={`/after-sale/purchase/suspension/${suspension.id}`}>
                                <ActionButton>
                                  📋 Vai a sospensione
                                </ActionButton>
                              </Link>
                            )}
                          </div>
                        </div>
                      </SuspensionCard>
                    ))
                  ) : (
                    <EmptyState className="suspensions-no-result">
                      <div className="empty-icon">📭</div>
                      <h5>Nessuna sospensione trovata!</h5>
                      <p>Prova a modificare i filtri di ricerca</p>
                    </EmptyState>
                  )}
                </SuspensionsListStyled>

                <div className="mt-4">
                  <Pagination
                    total_pages={total_pages}
                    current_page={page_number}
                    onClick={listSuspensions}
                    search={search}
                  />
                </div>
              </>
            )}
          </div>

          {/* Filters Sidebar */}
          <div className="col-lg-5 col-xl-4 col-xxl-3 order-1 order-lg-2 mb-4 mb-lg-0">
            <FilterCard className="suspensions-three">
              <h5>🔍 Filtri di Ricerca</h5>
              <form
                onSubmit={searchHandler}
                className="d-flex flex-column gap-3"
              >
                <div>
                  <label htmlFor="search">Ricerca cliente</label>
                  <input
                    type="text"
                    name="search"
                    id="search"
                    className="form-control"
                    value={search.search}
                    onChange={handleChange}
                    placeholder="Nome, cognome..."
                  />
                </div>

                <div>
                  <label htmlFor="vehicle_plate">Ricerca targa</label>
                  <input
                    type="text"
                    name="vehicle_plate"
                    id="vehicle_plate"
                    className="form-control"
                    value={search.vehicle_plate}
                    onChange={handleChange}
                    placeholder="Targa..."
                  />
                </div>

                <div>
                  <label htmlFor="date_from">Data creazione da</label>
                  <input
                    type="date"
                    name="date_from"
                    id="date_from"
                    onChange={handleChange}
                    value={search.date_from}
                    className="form-control"
                    lang="it-IT"
                  />
                </div>

                <div>
                  <label htmlFor="date_to">Data creazione al</label>
                  <input
                    type="date"
                    name="date_to"
                    id="date_to"
                    className="form-control"
                    onChange={handleChange}
                    value={search.date_to}
                    min={search.date_from}
                    lang="it-IT"
                  />
                </div>

                <SearchButton type="submit">
                  Cerca
                </SearchButton>
              </form>
            </FilterCard>
          </div>
        </div>
      </div>
    </SuspensionsListStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}

export default SuspensionsList;
